<style lang="less" scoped>
  @import "../../vars.less";
  .list{
    list-style: none;
    margin: 0;
  }
  .item {
    position: relative;
    padding: @space-normal;
    padding-left: calc(@space-normal + 4px);
    margin-bottom: @space-small;
    background-color: #fff;
    color: @text-color;
    font-size: 14px;
  }
  .title-container {
    display: flex;
    color: @text-color-important;
  }
  .title {
    flex: auto;
    font-size: 16px;
    font-weight: bold;
  }
  .title-right {
    flex: none;
    align-self: right;
    display: flex;
    justify-content: center;
    .icon {
      font-size: 20px;
      margin-right: @space-small;
    }
  }
  .done {
    .title-right {
      color: @primary-color;
    }
    .status-bar {
      background-color: @primary-color;
    }
  }
  .underway {
    .title-right {
      color: @warning-color;
    }
    .status-bar {
      background-color: @warning-color;
    }
  }
  .status-bar {
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
  }
  .content {
    display: flex;
    margin-top: @space-normal;
    padding-bottom: @space-medium;
  }
  .content-left {
    flex: auto;
  }
  .content-right {
    position: relative;
    right: -6px;
    flex: none;
    padding-left: @space-small;
    display: flex;
    align-items: center;
    font-size: 20px;
  }
  .content-item {
    margin: 0;
    display: flex;
    line-height: 1.8;
  }
  .label {
    flex: none;
    color: @text-color-secondary;
    margin-right: @space-normal;
  }
  .label:after {
    content: ":"
  }
  .value {
    flex: auto;
  }
  .extra {
    padding-top: @space-medium;
  }
  .extra-item {
    display: inline-flex;
    align-items: center;
  }
  .extra-item ~ .extra-item {
    margin-left: @space-large;
  }
  .extra-icon {
    width: 20px;
    margin-right: @space-small;
  }
  .extra-text {
    font-size: 14px;
    color: @text-color-secondary;
  }
</style>

<template>
  <page-container class="order-list"
    :title="$t('订单列表')"
    :infinity="true"
    :loading="loading"
    :finished="finished"
    :empty="!list.length"
    @load="getList"
    :safeAreaInsetBottom="false">
    <ul class="list">
      <li v-for="item of list"
        :key="item.orderNumber"
        class="item"
        :class="{
          done: item.order_status == 1
        }"
        @click="() => go2Detail(item)">
        <div class="status-bar" />
        <div class="title-container">
          <span class="title">
            {{ $t('SO') }}: {{ item.orderNumber }}
          </span>
          <span class="title-right">
            <van-icon v-if="item.order_status == 1" name="passed" class="icon"/>
            <van-icon v-if="item.order_status == 2" name="underway-o" class="icon"/>
            {{ item.order_status == 2 ? $t('未完成') : $t('已完成') }}
          </span>
        </div>
        <div class="content van-hairline--bottom">
          <div class="content-left">
            <p class="content-item">
              <span class="label">{{ $t('客户名称') }}</span>
              <span class="value">{{ item.customerName }}</span>
            </p>
            <p class="content-item">
              <span class="label">{{ $t('客户订单号') }}</span>
              <span class="value">{{ item.customerPO }}</span>
            </p>
            <p class="content-item">
              <span class="label">{{ $t('销售订单时间') }}</span>
              <span class="value">{{ item.orderDate }}</span>
            </p>
          </div>
          <div class="content-right">
            <van-icon name="arrow" />
          </div>
        </div>
        <div class="extra">
          <div class="extra-item">
            <img class="extra-icon"
              :src="`/images/shield${item.creditBlock ? '' : '-disabled'}.svg`"/>
            <span class="extra-text">{{ $t('信用锁定') }}</span>
          </div>
          <div class="extra-item">
            <img class="extra-icon"
              :src="`/images/shield${item.deliveryBlock ? '' : '-disabled'}.svg`"/>
            <span class="extra-text">{{ $t('发货锁定') }}</span>
          </div>
          <div class="extra-item">
            <img class="extra-icon"
              :src="`/images/shield${item.zminBlock ? '' : '-disabled'}.svg`"/>
            <span class="extra-text">{{ $t('ZMIN锁定') }}</span>
          </div>
        </div>
      </li>
    </ul>
  </page-container>
</template>

<script>
import { Icon } from 'vant'
import PageContainer from '../../components/PageContainer.vue'
import { LS_KEYS } from '../../constants'
import ls from '../../utils/local-storage'

export default {
  name: 'order-list',
  components: {
    'van-icon': Icon,
    PageContainer
  },
  data () {
    return {
      list: [],
      loading: false,
      finished: false,
      conditions: {
        ...(this.$route.query.conditions
          ? JSON.parse(this.$route.query.conditions)
          : {}),
        PageSize: 10,
        PageIndex: 1,
        IsPageView: true
      }
    }
  },
  computed: {
    isFavoritePage () {
      return this.$route.name === 'favorite-order-list'
    }
  },
  methods: {
    go2Detail (order) {
      this.$router.push({
        name: this.isFavoritePage ? 'favorite-order-detail' : 'order-detail',
        query: {
          orderNumber: order.orderNumber
        },
        params: {
          stackType: 'push'
        }
      })
    },
    handleList (res) {
      if (res) {
        this.list = this.list.concat(res)
        if (res.length < this.conditions.PageSize) {
          this.finished = true
        }
        if (res.length) {
          this.conditions.PageIndex++
        }
      }
    },
    getList () {
      if (this.$route.name === 'favorite-order-list') {
        this.$apis.order.getFavorites(
          ls.get(LS_KEYS.USERINFO).name,
          loading => (this.loading = loading)
        ).then(res => this.handleList(res))
      } else {
        this.$apis.order[this.$route.query.precise ? 'getPreciseList' : 'getList'](
          this.conditions,
          loading => (this.loading = loading)
        ).then(res => this.handleList(res))
      }
    }
  },
  mounted () {
    this.getList()
  }
}
</script>
